import { render, staticRenderFns } from "./OccurrencesModal.vue?vue&type=template&id=77452c98&"
import script from "./OccurrencesModal.vue?vue&type=script&lang=js&"
export * from "./OccurrencesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports